import React, { useEffect, useMemo, useState } from 'react';
import { css } from '@emotion/react';
import {
    ModalContent,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { Grid } from '@material-ui/core';
import GoogleMap, { Marker } from '@/components/GoogleMap';
import { genAttributes } from '@onward-delivery/core';

const DriverTrackingModal = ({ driver, open, order, callbacks }) => {
    const [location, setLocation] = useState(null);

    useEffect(() => {
        setLocation(null);
    }, [driver]);

    const defaultLocation = useMemo(() => {
        const { lat, long } = genAttributes(order);
        return { lat: order[lat], lng: order[long] };
    }, [order]);

    const isValid = useMemo(() => {
        return !!location?.lat && !!location?.lng;
    }, [location]);

    return (
        <ResponsiveSidebarDialog
            open={open}
            onClose={() => {
                setLocation(null);
                callbacks.onClose();
            }}
        >
            <ModalContent
                css={css`
                    width: 100%;
                `}
            >
                <Grid container direction="column">
                    <Grid
                        item
                        css={css`
                            width: 700px;
                            height: 350px;
                        `}
                    >
                        <GoogleMap
                            zoom={15}
                            onClick={(e) => {
                                setLocation({
                                    lat: e.latLng.lat(),
                                    lng: e.latLng.lng(),
                                });
                            }}
                            draggableCursor="pointer"
                            gestureHandling="greedy"
                            center={location ? location : defaultLocation}
                        >
                            {location && <Marker position={location} />}
                        </GoogleMap>
                    </Grid>
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid
                    container
                    direction="column"
                    css={css`
                        flex: 0;
                    `}
                >
                    <SecondaryButton
                        onClick={() => {
                            setLocation(null);
                            callbacks.onClose();
                        }}
                    >
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid
                    container
                    direction="column"
                    css={css`
                        flex: 0;
                    `}
                >
                    <PrimaryButton
                        disabled={!isValid}
                        onClick={() => {
                            callbacks.onConfirm({ driver, location });
                        }}
                    >
                        Save
                    </PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default DriverTrackingModal;
